import React from 'react';
import { Label } from '@gravity-ui/uikit';

interface StatusLabelProps {
  lockedAt?: string | null;
  lastLoggedInAt?: string | null;
  size?: 'xs' | 's' | 'm';
  className?: string;
  isUser?: boolean;
}

export const StatusLabel = ({
  lockedAt,
  lastLoggedInAt,
  size = 's',
  className,
  isUser
}: StatusLabelProps) => {
  if (lockedAt) {
    return (
      <Label size={size} theme={'danger'} className={className}>
        {isUser ? 'Запрещен вход' : 'Заблокирован'}
      </Label>
    );
  } else if (!lastLoggedInAt) {
    return (
      <Label size={size} theme={'unknown'} className={className}>
        Не авторизован
      </Label>
    );
  }
  return (
    <Label size={size} theme={'success'} className={className}>
      Активный
    </Label>
  );
}; 